module.exports = __webpack_public_path__ + "img/news9-3.7fbd76d2.png";